import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react'
import { ModalContext } from '../../Context';
import EditEventForm from '../ModalTemplate/EditEventForm';
import EventEditDeletePopUp from '../ModalTemplate/EventEditDeletePopUp';
import ReactCalendarPage from './ReactCalendarPage'
import { useTranslation } from 'react-i18next';

const AllEvent = ({ eventAllData, getEventApiData, adminData }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [showEvent, setShowEvent] = useState([]);
    const [year, setYear] = useState(new Date().getUTCFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const context = useContext(ModalContext)
    const { handleModalData } = context;
    const { t } = useTranslation();
    const formatDate = date => {
        const _date = new Date(date)
        const month = _date.getMonth() + 1
        const year = _date.getFullYear()
        const newdate = _date.getDate()
        return `${newdate}/${month}/${year}`
    }
    const formateTime = (time) => {
        // console.log(time, "timetime")
        const _Time = new Date(time);
        const hours = _Time.getHours();
        const minutes = _Time.getMinutes();
        const minutess =  minutes <10 ? `0${minutes}`: minutes
        const finalhours = hours > 12 ? hours-12 : hours
        const ampm = hours >= 12 ? 'pm' : 'am';
        const FullTime = `${finalhours}: ${minutess} ${ampm}`
        return FullTime
    }

    // const formateTime = (time) => {
    //     // var ts = time;
    //     // var H = +ts.substr(0, 2);
    //     // var h = (H % 12) || 12;
    //     // h = (h < 10)?("0"+h):h;  // leading 0 at the left for 1 digit hours
    //     // var ampm = H < 12 ? " AM" : " PM";
    //     // ts = h + ts.substr(2, 3) + ampm;
    //     // return ts;
    //     // const date = new Date(time);
    //     const date = new Date(time);
    //     console.log(date);
    //     console.log(date.toLocaleTimeString()); 
    //     return date.toLocaleTimeString()
    //   };

    const getAllApiDataOnLoad = () => {
        setShowEvent([])
        let arry = []
        eventAllData && eventAllData.map((item) => {
            const _date = new Date(item.current)
            const _d1 = formatDate(_date)
            const _d2 = formatDate(currentDate)
            if (_d1 === _d2) {
                arry.push(item)
            }
            else {
                // console.log(false);
                // setShowEvent([])
            }
        })

        setShowEvent(arry)

    }

    useEffect(() => {
        getAllApiDataOnLoad();
    }, [eventAllData])


    const dateHandler = (date) => {
        setCurrentDate(date)
        setShowEvent([])
        let arry = []
        eventAllData.map((item) => {
            const _date = new Date(item.current)
            const _d1 = formatDate(_date)
            const _d2 = formatDate(date)
            if (_d1 === _d2) {
                arry.push(item)
            }
            else {
                console.log(false);
            }
            setShowEvent(arry)
        })
    }

    const handleActiveStartDate = (value) => {
        const _yearMonth = value.activeStartDate;
        const year = _yearMonth.getFullYear();
        const month = _yearMonth.getMonth() + 1;
        setYear(year)
        setMonth(month)
    }
    useEffect(() => {
        getEventApiData(year, month);
    }, [year, month]);

    // console.log(showEvent, "showEvent")

    const handleEditEventShow = (data, id,eventId) => {
        const edit_Form_Modal =
            // <EditEventForm
            //     title="Edit Event"
            //     buttonText="Save"
            //     getEventApiData={getEventApiData}
            //     eventDetails={data}
            //     eventId={id}
            // />
            <EventEditDeletePopUp
                title={t('EDIT_EVENT')}
                buttonText={t('SAVE')}
                getEventApiData={getEventApiData}
                eventDetails={data}
                eventId={id}
                adminData={adminData}
                eventIds={eventId}
            />
        handleModalData(edit_Form_Modal)  // Only I need to paist this in other event page not commented ki jagah
    }

    return (
        <div className="grid xl:grid-cols-4 md:grid-cols-3 ">
            <div className="col-span-3">
                <ReactCalendarPage eventAllData ={eventAllData} showEvent ={showEvent}  value={currentDate} onChange={dateHandler} activeStartDateChange={handleActiveStartDate} />
                <div className="my-8 flex items-center">
                    <div className="flex items-center mr-4">
                        <span className="w-4 h-4 rounded-full bg-sidenav" />
                        <span className="text-paraText ml-2">{t('Offline_Calendar')}</span>
                    </div>
                    <div className="flex items-center mx-4">
                        <span className="w-4 h-4 rounded-full bg-bgOrange" />
                        <span className="text-paraText ml-2">{t('Digital_Calendar')}</span>
                    </div>
                </div>
            </div>
            <div className="details_main">
                <div className="sticky top-0 sticky-sidebar">
                    <h2 className="text-sidenav text-2xl pb-2 pl-4">{t('Details')}</h2>
                    {
                        showEvent.length > 0 ? (
                            showEvent.map(item => (
                                <div
                                    className={`p-5 cursor-pointer mb-5 ${item.postTo == "offline" ? "bg-sidenav" : "bg-bgOrange"}`
                                    }
                                    key={item._id}
                                    onClick={() => handleEditEventShow(item, item._id,item?.eventId)}
                                >
                                    <h3
                                        className={`text-lg pb-3 ${item.postTo == "offline" ? "text-white" : "text-white"}`}>
                                     {t('Event_Name')} :{item.name}
                                    </h3>
                                    <h3
                                        className={`text-md pb-3 ${item.postTo == "offline" ? "text-white" : "text-white"} `}
                                    >
                                      {t('Event_Description')}: {item.description}
                                    </h3>
                                    <p className={`text-sm py-1 ${item.postTo == "offline" ? "text-white" : "text-white"}`}>{t('Event_Date')} :{`${formatDate(item.start)} to ${formatDate(item.end)}`} </p>
                                    <p
                                        className={`text-sm ${item.postTo == "offline" ? "text-white" : "text-white"}`}
                                    >
                                        {/* {`${(item.startTime)} to ${(item.endTime)}`} */}
                                        {t('Event_Time')}: {`${formateTime(item.startTime)} to ${formateTime(item.endTime)}`}
                                       {/* { `${moment(item.startTime).format('h:mm:ss a')} to ${moment(item.endTime).format('h:mm:ss a')}`} */}
                                    </p>
                                    <p
                                        className={`text-sm py-1 ${item.postTo == "offline" ? "text-white" : "text-white"}`}
                                    >
                                      {t('Event_Timezone')} :  {item.timezone}
                                    </p>
                                    <p
                                        className={`text_tosmall_10 ${item.postTo == "offline" ? "text-white" : "text-white"}`}
                                    >
                                        {item && item.links && item.links.map((item2, index) => {
                                            return (
                                                <>
                                                    <div key={index}>
                                                        <p>{item2}</p>
                                                    </div>
                                                </>
                                            )
                                        })}
                                    </p>
                                </div>
                            ))

                        ) : (

                            <div className="ml-5">
                                <p>No Events for today</p>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default AllEvent
